// Shared compact UI tokens (13px base, matches the sidebar and dashboard).
// Theme: blue primary, orange secondary, green tertiary, black text.
export const btn =
  "inline-flex items-center justify-center gap-1.5 h-9 px-3.5 rounded-lg text-[13px] font-semibold whitespace-nowrap transition-colors disabled:opacity-60 disabled:cursor-not-allowed";
export const btnPrimary = `${btn} bg-blue-600 text-white hover:bg-blue-700 shadow-sm`;
export const btnOutline = `${btn} border border-slate-300 bg-white text-neutral-800 hover:border-blue-300 hover:text-blue-600`;
export const btnDanger = `${btn} bg-red-600 text-white hover:bg-red-700`;
export const iconBtn = "inline-flex items-center justify-center w-8 h-8 rounded-lg text-slate-500 transition-colors";

export const inputCls =
  "w-full h-9 rounded-lg bg-white border border-slate-300 px-3 text-[13px] text-neutral-900 placeholder:text-slate-400 outline-none transition " +
  "focus:border-blue-600 focus:ring-2 focus:ring-blue-600/15 disabled:bg-slate-50 disabled:text-slate-400";
export const inputErrCls = "!border-red-500 focus:!border-red-500 focus:!ring-red-500/15";
export const labelCls = "block text-[12px] font-semibold text-slate-700 mb-1";
export const cardCls = "rounded-xl bg-white border border-slate-200 shadow-sm";
export const pageTitle = "font-display text-[20px] font-bold text-neutral-900";
export const pageSub = "text-[13px] text-slate-500";

export const inr = (n) => "₹" + (Number(n) || 0).toLocaleString("en-IN");

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};
export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return `${fmtDate(iso)}, ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};
